






















































































































































































import { Component, Mixins, Watch, Vue } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import CustomForm from '@/components/custom-form/index.vue'
import OrderApi from '@/api/order/list'
import ViewUI from 'view-design'
@Component({
  components: {
    CustomForm,
  },
})
export default class OrderList extends AbpBase {
  filters1 = [
    {
      label: '输入搜索',
      type: 'input',
      props: {
        placeholder: '订单编号',
      },
      key: 'orderNo',
    },
    {
      label: '收货人：',
      type: 'input',
      props: {
        placeholder: '收货人姓名/手机号码',
      },
      key: 'shippingInfo',
    },
    {
      label: '类型',
      type: 'select',
      props: {
        placeholder: '请选择订单类型',
        clearable: true,
      },
      options: [
        {
          value: '0',
          text: '常规订单',
        },
        {
          value: '1',
          text: '拼团订单',
        },
        {
          value: '2',
          text: '积分订单',
        },
        {
          value: '3',
          text: '预售订单',
        },
        {
          value: '4',
          text: '卡密订单'
        }
      ],
      key: 'orderType',
    },
    {
      label: '下单时间',
      type: 'daterange',
      key: 'date',
      defaultValue: [],
    },
  ]
  filter2 = [
    {
      label: '输入搜索：',
      type: 'input',
      props: {
        placeholder: '订单编号',
      },
      key: 'orderNo',
    },
    {
      label: '收货人：',
      type: 'input',
      props: {
        placeholder: '收货人姓名/手机号码',
      },
      key: 'shippingInfo',
    },
    {
      label: '提交时间：',
      type: 'date',
      key: 'date',
      defaultValue: '',
    },
  ]
  columns: any[] = [
    {
      type: 'selection',
      width: 60,
      align: 'center',
    },
    {
      title: '订单编号',
      key: 'orderNo',
      align: 'center',
    },
    {
      title: '管易单号',
      key: 'tradeNo',
      align: 'center',
    },
    {
      title: '商品信息',
      slot: 'orderItems',
      width: 300,
      align: 'center',
    },
    {
      title: '订单金额',
      slot: 'payAmount',
      align: 'center',
    },
    {
      title: '订单类型',
      slot: 'orderType',
      align: 'center',
    },
    {
      title: '收货人',
      slot: 'shippingAddress',
      align: 'center',
    },
    {
      title: '订单状态',
      key: 'orderFullStatusStr',
      align: 'center',
    },
    {
      title: '下单时间',
      slot: 'creationTime',
      align: 'center',
    },
    {
      title: '备注',
      key: 'remark',
      align: 'center',
    },
    {
      title: '操作',
      slot: 'action',
      width: 150,
      align: 'center',
    },
  ]
  loading: boolean = false
  tableData: any[] = []
  page = {
    totalCount: 0,
    currentPage: 1,
    maxResultCount: 10,
  }
  //订单整体状态 0 待支付/1 待发货/2 待收货/3 待评价/4 已取消/5 已评价/20 待成团
  tabList = [
    {
      text: '全部订单',
      value: null,
    },
    {
      text: '待支付',
      value: 0,
    },
    {
      text: '待成团',
      value: 20,
    },
    {
      text: '待发货',
      value: 1,
    },
    {
      text: '已发货',
      value: 2,
    },
    {
      text: '已完成',
      value: 3,
    },
    {
      text: '已评价',
      value: 5,
    },
    {
      text: '已取消',
      value: 4,
    },
    // {
    //   text: '已关闭',
    //   value: 6
    // }
  ]
  activeTab = 0
  isCheckAll: boolean = false
  exporting: boolean = false
  selectedIds: any = new Set()

  get filters() {
    if (this.$route.name == 'orderList') {
      return this.filters1
    } else {
      return this.filter2
    }
  }

  mounted() {}

  @Watch('$route', {
    immediate: true,
  })
  routeWatch() {
    ViewUI['LoadingBar'].finish()
    this.activeTab = 0
    this.page = {
      totalCount: 0,
      currentPage: 1,
      maxResultCount: 10,
    }
    this.tableData = []
    let form: any = this.$refs.lineForm
    if (form) {
      form.reset()
    }

    this.getOrderList()
  }
  // 同步导出订单
  exportExcel() {
    let refForm: any = this.$refs.lineForm
    const form = refForm.getForm()
    console.log(form)
    let { page, activeTab, tabList } = this
    this.exporting = true
    let orderNo = form ? form['orderNo'] : null
    let shippingInfo = form ? form['shippingInfo'] : null
    // let date = form['date'] ? this.dateString(form['date'][0]) : null
    let StartTime = form['date'] ? this.dateString(form['date'][0]) : null
    let EndTime = form['date'] ? this.dateString(form['date'][1]) : null
    let orderType = this.$route.name == 'rewardPointOrderList' ? 2 : form ? form['orderType'] : null
    let orderFullStatus = tabList[activeTab].value

    // let selection = (this.$refs.selection as any).getSelection()
    let OrderIds: any = [...this.selectedIds]
    // if (selection.length) {
    //   OrderIds = selection.map(item => item.id)
    // }
    OrderApi.exportExcel(
      // OrderIds ? page.maxResultCount : page.totalCount > 500 ? 500 : page.totalCount,
      page.totalCount,
      // OrderIds ? page.currentPage : 1,
      1,
      orderNo,
      shippingInfo,
      // date,
      orderFullStatus,
      orderType,
      '',
      OrderIds,
      StartTime,
      EndTime
    )
      .then((res) => {
        this.exporting = false
        this.download(res.data)
      })
      .catch((err) => {
        this.exporting = false
      })
  }
  // 异步导出订单
  exportExcelSync() {
    let refForm: any = this.$refs.lineForm
    const form = refForm.getForm()
    console.log(form)
    let { page, activeTab, tabList } = this
    this.exporting = true
    let orderNo = form ? form['orderNo'] : null
    let shippingInfo = form ? form['shippingInfo'] : null
    let StartTime = form['date'] ? this.dateString(form['date'][0]) : null
    let EndTime = form['date'] ? this.dateString(form['date'][1]) : null
    let orderType = this.$route.name == 'rewardPointOrderList' ? 2 : form ? form['orderType'] : null
    let orderFullStatus = tabList[activeTab].value

    let OrderIds: any = [...this.selectedIds]
    OrderApi.exportExcelSync(
      page.totalCount,
      1,
      orderNo,
      shippingInfo,
      // date,
      orderFullStatus,
      orderType,
      '',
      OrderIds,
      StartTime,
      EndTime
    ).then(res => {
      this.exporting = false
      this.$Notice.success({
        desc: '创建任务成功'
      })
      this.$router.push({
        name: 'exportExcelRecord'
      })
    }).catch(err => {
      this.exporting = false
    })
  }
  // 导出记录
  exportExcelRecord() {
    this.$router.push({
      name: 'exportExcelRecord'
    })
  }

  get showBatchCancel() {
    // 已发货/已完成/已评价/已取消不显示
    // {
    //   text: '已发货',
    //   value: 2
    // },
    // {
    //   text: '已完成',
    //   value: 3
    // },
    // {
    //   text: '已评价',
    //   value: 5
    // },
    // {
    //   text: '已取消',
    //   value: 4
    // }
    return ![2, 3, 5, 4].includes(this.tabList[this.activeTab].value)
  }

  get showBatchDeleted() {
    // 已取消/已关闭显示
    // {
    //   text: '已关闭',
    //   value: 6
    // },
    // {
    //   text: '已取消',
    //   value: 4
    // }
    return [null, 4, 6].includes(this.tabList[this.activeTab].value)
  }
  get showBatchPrint() {
    // 待发货显示
    // {
    //   text: '待发货',
    //   value: 1
    // }
    return [null, 1].includes(this.tabList[this.activeTab].value)
  }

  download(data) {
    if (!data) {
      return
    }
    let url = window.URL.createObjectURL(new Blob([data]))
    let link = document.createElement('a')
    link.style.display = 'none'
    link.href = url
    link.setAttribute('download', '订单列表.xlsx')

    document.body.appendChild(link)
    link.click()
  }
  submitFn() {
    let form: any = this.$refs.lineForm
    form.submit()
  }

  onSubmit(form, valid) {
    if (valid) {
      this.getOrderList(form)
    } else {
      this.$Message.error('验证失败')
    }
  }

  orderTypeString(type) {
    let text = type
    switch (type) {
      case 0:
        text = '常规订单'
        break
      case 1:
        text = '拼团订单'
        break
      case 2:
        text = '积分订单'
        break
      case 3:
        text = '预售订单'
        break
      case 4:
        text = '卡密订单'
        break;
    }

    return text
  }

  changePage(e) {
    this.page.currentPage = e
    this.submitFn()
    setTimeout(() => {
      this.setChecked()
    }, 200)
  }
  pageSizeChange(e) {
    this.page.maxResultCount = e
    this.page.currentPage = 1
    this.submitFn()
  }

  /**
   * 获取订单列表
   */
  getOrderList(form?) {
    let { page, activeTab, tabList } = this
    this.loading = true
    this.isCheckAll = false
    let orderNo = form ? form['orderNo'] : null
    let shippingInfo = form ? form['shippingInfo'] : null
    console.log('test', form)
    let date = form ? this.dateString(form['date']) : null
    let begin = form ? this.dateString(form['date'][0]) : null
    let end = form ? this.dateString(form['date'][1]) : null

    let orderType = this.$route.name == 'rewardPointOrderList' ? 2 : form ? form['orderType'] : null
    let orderFullStatus = tabList[activeTab].value
    OrderApi.getOrderList(
      page.maxResultCount,
      page.currentPage,
      orderNo,
      shippingInfo,
      begin,
      end,
      orderFullStatus,
      orderType
    )
      .then((res) => {
        this.loading = false
        if (res.data) {
          this.tableData = res.data.items
          page.totalCount = res.data.totalCount
        }
      })
      .catch((err) => {
        this.loading = false
      })
  }
  /**
   * 查看订单详情
   */
  orderDetailFn(row) {
    this.$router.push({
      name: 'orderDetail',
      query: {
        id: row.id,
      },
    })
  }
  /**
   * 批量发货
   */
  deliverGoodFn() {
    let selection = (this.$refs.selection as any).getSelection()
    if (selection.length) {
      let idlist = selection.map((item) => item.id)
      this.$router.push({
        name: 'deliverGood',
        query: {
          id: JSON.stringify(idlist),
        },
      })
    } else {
      this.$Notice.warning({
        title: '请先选择订单',
      })
    }
  }

  /**
   * 发货
   */
  shipmentFN(row) {
    this.$router.push({
      name: 'deliverGood',
      query: {
        id: row.id,
      },
    })
  }

  /**
   * 取消待付款订单
   */
  cancelOrder(row) {
    this.$Modal.confirm({
      title: '提示',
      content: '确认取消此订单？',
      onOk: () => {
        this.loading = true
        let list: any = [row.id]
        OrderApi.cancelOrder(list)
          .then((res) => {
            this.loading = false
            this.$Notice.success({ desc: '取消成功' })
            this.submitFn()
          })
          .catch((err) => {
            this.loading = false
          })
      },
    })
  }

  cancelOrderAll() {
    let selection = (this.$refs.selection as any).getSelection()
    const ids: any[] = []
    selection.forEach((x) => {
      if (x.orderFullStatus < 2 || x.orderFullStatus == 20) {
        ids.push(x.id)
      }
    })
    if (ids.length === 0) {
      this.$Notice.warning({ title: '请先勾选待支付/待发货/待成团订单' })
      return
    } else {
      this.$Modal.confirm({
        title: '提示',
        content: '确认取消已选中的待支付/待发货/待成团订单？',
        onOk: () => {
          this.loading = true
          OrderApi.cancelOrder(ids)
            .then((res) => {
              this.loading = false
              this.$Notice.success({ desc: '取消成功' })
              this.submitFn()
            })
            .catch((err) => {
              this.loading = false
            })
        },
      })
    }
  }

  /**
   * 批量删除已取消/已关闭订单
   */
  deleteSelectd() {
    let selection = (this.$refs.selection as any).getSelection()
    const ids: any = []
    selection.forEach((x) => {
      if (x.orderFullStatus === 4 || x.orderFullStatus === 6) {
        ids.push(x.id)
      }
    })
    if (ids.length === 0) {
      this.$Notice.warning({ title: '请先勾选已取消/已关闭订单' })
      return
    } else {
      this.$Modal.confirm({
        title: '提示',
        content: `确认删除已取消/已关闭订单？`,
        onOk: () => {
          this.loading = true
          OrderApi.deleteOrder(ids)
            .then((res) => {
              this.loading = false
              this.$Notice.error({ desc: '删除成功' })
              this.submitFn()
            })
            .catch((err) => {
              this.loading = false
            })
        },
      })
    }
  }

  handleTableAllCancel() {
    this.isCheckAll = false
    let data = (this.$refs.selection as any).data
    data.forEach((item) => {
      if (this.selectedIds.has(item.id)) {
        this.selectedIds.delete(item.id)
      }
    })
  }

  handleTableAll(selection) {
    this.isCheckAll = true
    selection.forEach((item) => {
      this.selectedIds.add(item.id)
    })
  }

  handleSelectChange(selection) {
    this.isCheckAll = selection.length === this.tableData.length
  }

  handleSelectAll() {
    if (!this.tableData.length) return
    ;(this.$refs.selection as any).selectAll(!this.isCheckAll)
  }
  handleSelect(slection, row) {
    this.selectedIds.add(row.id)
  }
  handleCancel(slection, row) {
    this.selectedIds.delete(row.id)
  }
  setChecked() {
    // 找到绑定的table的ref对应的dom，找到table的objData对象，objData保存的是当前页的数据
    let objData = (this.$refs.selection as any).objData
    for (let index in objData) {
      if (this.selectedIds.has(objData[index].id)) {
        // cy 弊端 每次切换select都会触发table的on-select事件
        // this.$refs.purchaseTable.toggleSelect(index) // 在保存选中的ids的set合集里找与当前页数据id一样的行，使用toggleSelect（index），将这一行选中
        // cy 改进
        objData[index]._isChecked = true
      }
    }
    // console.log(objData)
  }
  // 打印发货单
  printOrder() {
    var selected = (this.$refs.selection as any).getSelection()
    const ids: any[] = []
    selected.forEach((x) => {
      if (x.orderFullStatus === 1) {
        ids.push(x.id)
      }
    })
    if (ids.length === 0) {
      this.$Notice.warning({ title: '请先勾选待发货订单' })
      return
    } else {
      this.$router.push({
        name: 'printOrder',
        params: {
          ids: encodeURIComponent(ids.join(',')),
        },
      })
    }
  }
  // 推送到管易
  pushToManage(row) {
    this.loading = true
    OrderApi.erpOrder(row.orderNo)
      .then((res) => {
        this.loading = false
        this.$Notice.success({ desc: '推送成功' })
        this.submitFn()
      })
      .catch((err) => {
        this.loading = false
      })
  }
}
